var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsClockwise = function SvgIconArrowsClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.75a7.24 7.24 0 0 0-5.123 2.125A1 1 0 0 1 5.46 5.462a9.24 9.24 0 0 1 13.077 0l1.48 1.476V4.847a1 1 0 0 1 2 0v4.5a1 1 0 0 1-1 1h-4.5a1 1 0 0 1 0-2H18.6l-1.475-1.47-.001-.002A7.24 7.24 0 0 0 12 4.751M1.981 14.653a1 1 0 0 1 1-1h4.5a1 1 0 1 1 0 2h-2.08l1.476 1.472a7.24 7.24 0 0 0 10.247 0 1 1 0 0 1 1.415 1.413 9.24 9.24 0 0 1-13.077 0l-1.48-1.476v2.091a1 1 0 1 1-2 0z"
  }))));
};
export default SvgIconArrowsClockwise;